export default "__VITE_ASSET__e571c120__"